import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AuthCallback() {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Invalid authentication response');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Retrieve referral code stored before Google redirect
        const referralCode = localStorage.getItem('hustlehub_ref') || null;

        // Exchange session_id for user data and session_token
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId,
          referral_code: referralCode,
        }, {
          withCredentials: true
        });

        // Clear referral code after use
        localStorage.removeItem('hustlehub_ref');

        const { user, session_token } = response.data;

        // Persist session token in localStorage for Authorization header fallback
        if (session_token) {
          localStorage.setItem('hustlehub_session', session_token);
        }

        // Refresh auth context to pick up the new session
        await refreshAuth();

        // Clear hash from URL and navigate
        // If new user (just created), go to questionnaire first
        const isNewUser = !user?.has_completed_profile;
        const destination = isNewUser ? '/match' : '/dashboard';
        navigate(destination, { state: { user }, replace: true });
        
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, refreshAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#10B981]"></div>
        <p className="mt-4 text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
